import { useEffect, useRef } from 'react'

/** Sentinel + IntersectionObserver inside a scroll root. Best for panel lists. */
export default function useInfiniteScroll({ rootRef, hasMore, loading, onLoadMore }) {
  const sentinelRef = useRef(null)

  useEffect(() => {
    if (!hasMore || loading) return
    const root = rootRef.current
    const target = sentinelRef.current
    if (!root || !target) return

    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) onLoadMore() },
      { root, rootMargin: '80px' }
    )
    observer.observe(target)
    return () => observer.disconnect()
  }, [hasMore, loading, onLoadMore, rootRef])

  return sentinelRef
}

export function hasMorePages(meta = {}, loadedCount = 0) {
  const count = meta?.pagination?.count
  if (count != null) return loadedCount < count
  if (meta?.pagination?.next != null) return true
  return false
}
